// src/hooks/useSettings.js
import { useState, useEffect } from 'react';

const LOCAL_STORAGE_KEY = 'pomodoro_settings';

export function useSettings() {
  // Default to 'dark'
  const [settings, setSettings] = useState({
    pomodoroDuration: 25 * 60,
    shortBreakDuration: 5 * 60,
    longBreakDuration: 15 * 60,
    autoStart: false,
    notificationEnabled: false,
    soundEnabled: true,
    notificationSound: '',
    theme: 'dark',
  });

  useEffect(() => {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        setSettings((prev) => ({ ...prev, ...parsed }));
      } catch (err) {
        console.error('Error parsing settings from LS:', err);
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(settings));
  }, [settings]);

  return [settings, setSettings];
}
